module.exports = __webpack_public_path__ + "img/banner.8d061005.png";